<template>
  <div>
    <div class="loading-backdrop" style="z-index:10000">
      <div class="row justify-content-center h-100">
        <div class="align-self-center text-center">
          <div class="loading-logo-container">
            <div class="loading-content">
              <!-- Círculos animados de fondo -->
              <div class="loading-circles">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
                <div class="circle circle-3"></div>
              </div>
              <!-- Partículas orbitando -->
              <div class="particles">
                <div class="particle particle-1"></div>
                <div class="particle particle-2"></div>
                <div class="particle particle-3"></div>
                <div class="particle particle-4"></div>
              </div>
              <!-- Halo blanco detrás del logo para darle brillo y contraste -->

              <!-- Logo principal -->
              <img
                src="/img/geopark-logo.svg"
                alt="Geopark Logo"
                class="loading-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import { ScaleLoader } from "@saeris/vue-spinners";
export default {
  name: "Loading",
  components: {
    //ScaleLoader,
  },
};
</script>
<style>
.loading-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 300px;
  margin: 0 auto;
}
/* Círculos animados de fondo */
.loading-circles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}
.circle {
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Aro con degradado rojo */
  background: conic-gradient(#ff4b4b, #b00020, #ff6b6b);
  -webkit-mask: radial-gradient(
    closest-side,
    transparent calc(100% - 2px),
    #000 0
  );
  mask: radial-gradient(closest-side, transparent calc(100% - 2px), #000 0);
}
.circle-1 {
  width: 120px;
  height: 120px;
  animation: rotate 4s linear infinite;
}
.circle-2 {
  width: 180px;
  height: 180px;
  animation: rotate 6s linear infinite reverse;
}
.circle-3 {
  width: 240px;
  height: 240px;
  animation: rotate 8s linear infinite;
}
/* Logo principal */

.loading-logo {
  width: 100px;
  height: 100px;
  animation: pulse 2s ease-in-out infinite;
  z-index: 6;
  position: absolute;
  top: 43.9.8%;
  left: 43.9.8%;
  transform: translate(-50%, -50%);
  margin-top: 0px;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
}
/* Partículas orbitando */
.particles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: 180px;
}
.particle {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #ff0000; /* gris */
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
}
.particle-1 {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation: orbit 3s linear infinite;
}
.particle-2 {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  animation: orbit 3s linear infinite;
  animation-delay: 0.75s;
}
.particle-3 {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation: orbit 3s linear infinite;
  animation-delay: 1.5s;
}
.particle-4 {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  animation: orbit 3s linear infinite;
  animation-delay: 2.25s;
}
.loading-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.35);
}

/* Animación de rotación para círculos */
@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
/* Animación de pulso para el logo */
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}
/* Animación de órbita para partículas */
@keyframes orbit {
  0% {
    transform: rotate(0deg) translateX(90px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(90px) rotate(-360deg);
  }
}
</style>
 